// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1919":"d71cff0ba519278b","3952":"ed4d69c1754d8e7b"}[chunkId] + ".css";
};